import React from 'react'
import Our_Journey from './our-journey/Our_Journey'
import Core_Features from './core-features/Core_Features'
import WhyChooseDream11 from './why-choose-dream11/Why_Choose_Dream11'
import ExperienceTheGameLikeNeverBefore from './experience-the-game-like-never-before/Experience_The_Game_Like_Never_Before'

function About_Us() {
  return (
 <>
 <Our_Journey/>
 <Core_Features/>
 <WhyChooseDream11/>
 <ExperienceTheGameLikeNeverBefore/>
 </>
  )
}

export default About_Us